import { useEffect, useState } from "react";
import ReactQuill from "react-quill-new";

interface Prop_Editor{
  className?:string
  html?:string;
  viewMode?:boolean;
  onUpdate?:( html:string)=>void
}

export default function Editor( prop:Prop_Editor){
  const [contents, set_contents]=useState( prop.html );
  useEffect(()=>{
    const proc=()=>{
      set_contents( prop.html )
    }
    proc();
  },[prop.html])
  function _updateContents(){
    console.log("update")
    if(prop.onUpdate)prop.onUpdate(contents?contents:'')
  }
  return<div className={`${prop.className}`}>
    {prop.viewMode==true&&
      <ReactQuill 
        theme=""
        readOnly={true}
        value={contents} 
      />
    }

    {prop.viewMode!=true&&    
      <ReactQuill 
        value={contents} 
        // onChangeSelection={()=>_updateContents()}
        onBlur={()=>_updateContents()}
        onChange={(v:string)=>set_contents(v)}/>
        // onChange={(v:string)=>prop.onUpdate&&prop.onUpdate(v)}/>
    }
  </div>
}